import { createTheme } from '@mui/material/styles';
import { COLOR } from './colors';
import typography from './typography';
import { buttonTheme } from './button';
import { textFieldTheme } from './textField';
export const customTheme = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 320,
            md: 768,
            lg: 1200,
            xl: 1536,
        },
    },
    palette: {
        primary: {
            main: COLOR.commonColor.primary,
            dark: COLOR.primaryGreyScale['600'],
        },
        secondary: {
            main: COLOR.commonColor.secondary,
            dark: COLOR.commonColor.secondaryDark,
            contrastText: '#fff',
        },
        error: {
            main: COLOR.commonColor.red,
        },
        warning: {
            main: COLOR.commonColor.yellow,
        },
        success: {
            main: COLOR.commonColor.green,
        },
        text: {
            primary: COLOR.textColor.primary,
            secondary: COLOR.textColor.secondary,
        },
        statusColor: COLOR.statusColor,
        dividerLight: 'rgba(255, 255, 255, 0.4)',
    },
    typography,
    components: Object.assign(Object.assign({}, buttonTheme), textFieldTheme),
};
const theme = createTheme(customTheme);
export { theme };
